import { SVGProps } from 'react';

const SvgPackageMove = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M14.817 4.331a2.285 2.285 0 0 1 2.366 0l.002.002 4.667 2.8c.356.216.646.523.845.885.2.362.303.769.303 1.18v5.603c0 .411-.104.82-.303 1.181-.2.362-.49.669-.845.885l-.004.002-4.663 2.799h-.002a2.284 2.284 0 0 1-2.366 0h-.002l-4.663-2.799-.004-.002a2.368 2.368 0 0 1-.845-.885A2.455 2.455 0 0 1 9 14.802V9.199c0-.411.104-.82.303-1.181.2-.362.49-.669.845-.885l.004-.002 4.663-2.798.002-.002ZM17 17.446l3.815-2.29h.001a.37.37 0 0 0 .129-.138A.456.456 0 0 0 21 14.8v-4.182l-4 2v4.828Zm-1-6.564 4.48-2.24-4.332-2.6A.285.285 0 0 0 16 6c-.049 0-.1.013-.148.043l-.004.002-4.328 2.597 4.48 2.24Zm-5-.264V14.8c0 .079.02.154.055.218a.37.37 0 0 0 .129.138h.001L15 17.447v-4.828l-4-2ZM1 8a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2H2a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgPackageMove;
